import React from 'react';
import PropTypes from 'prop-types';

import ScoreItem from "./components/ScoreItem";

ScoreGrid.propTypes = {
    scores: PropTypes.object.isRequired,
};

function ScoreGrid({scores}) {
    return (
        <div style={{display: "flex", gap: "24px"}}>
            <ScoreItem
                value={scores.seo}
                label={'SEO'}
            />
            <ScoreItem
                value={scores.marketplace}
                label={'Marketplace'}
            />
            <ScoreItem
                value={scores.store}
                label={'Store'}
            />
        </div>
    );
}

export default ScoreGrid;
